import { render } from "./register-form.vue?vue&type=template&id=52fab82c&scoped=true"
import script from "./register-form.vue?vue&type=script&lang=js"
export * from "./register-form.vue?vue&type=script&lang=js"

import "./register-form.vue?vue&type=style&index=0&id=52fab82c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52fab82c"]])

export default __exports__